import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";
import DeviceControlButton from "nexia_mobile/components/Controls/DeviceControlButton";
import Platform from "nexia_mobile/platform";
import safelyOpen from "nexia_mobile/safelyOpen";
import UserAgent from "nx-components/UserAgent";
import { showAlertDialog } from "nexia_mobile/components/Dialogs/AlertDialog";

class NestCamera extends React.Component {
  static propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
    isDetailed: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    this.determineVideoLaunchStrategy();
  }

  determineVideoLaunchStrategy() {
    // We need to decide this ahead of time because WKWebView will only
    // care about safelyOpen calls that happened as the result of user
    // interaction, and going async with the _isNestInstalled Promise
    // will lose that context.
    if (Platform.isMobilePlatform()) {
      this._isNestInstalled()
        .then((isInstalled) => {
          if (isInstalled) {
            this._launchVideo = this._launchNestInApp;
          } else {
            this._launchVideo = this._showDialog;
          }
        })
        .catch(() => {
          // if a platform bridge error occured we can't verify if Nest exists, so assume not
          this._launchVideo = this._showDialog;
        });
    } else {
      this._launchVideo = this._launchNestInBrowser;
    }
  }

  _launchNestInApp() {
    return safelyOpen(this.props.model.get("streamAppUrl"));
  }

  _launchNestInBrowser() {
    return safelyOpen(this.props.model.get("streamWebUrl"));
  }

  _isNestInstalled() {
    if (!this._mobilePlatformSupportsNest()) {
      return Promise.resolve(false);
    }
    return Platform.hasAppInstalled("nest");
  }

  _mobilePlatformSupportsNest() {
    return !UserAgent.isWindows();
  }

  _showDialog() {
    let notAvailable =
      "The Nest application is not available for your platform.";
    let pleaseInstall =
      "Please install the Nest application for your platform.";
    let message = this._mobilePlatformSupportsNest()
      ? pleaseInstall
      : notAvailable;
    showAlertDialog({ message });
  }

  render() {
    const { model, isDetailed } = this.props;

    return (
      <CommonControlWrapper isDetailed={isDetailed}>
        <DeviceControlButton
          buttonLabel="Show Video"
          disabled={!model.isConnected()}
          needsTrustedTap
          onTap={() => this._launchVideo()}
        />
      </CommonControlWrapper>
    );
  }
}

export default NestCamera;



// WEBPACK FOOTER //
// ./src/components/Controls/NestCamera.jsx